import { useDataChange } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'new_relation',
    path: 'address',
  })

  let onChooseAddress = ({ street, city, state, zip }) => {
    change(next => {
      next.address_line1 = street || ''
      next.city = city || ''
      next.state = state || ''
      next.zip = zip || ''
    })
  }

  return <View {...props} onChooseAddress={onChooseAddress} />
}
